import {inject, Injectable} from "@angular/core";
import {Router} from "@angular/router";
import {getAuth} from "firebase/auth";
import {SessionQuery} from "../stores/session/session.query";

export const AuthGuard = async () => {
  const _router = inject(Router);
  const _session = inject(SessionQuery);
  const token = _session.jwt;
  if (token) {
    return true;
  } else {
    _router.navigateByUrl('/login');
    return false;
  }
};
